import $, { data } from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';


export class Select2FormBuilder {

    constructor(el, customOption = false) {
        this.el = el; 
        this.init(customOption); 
    }

    init(customOption) {
        if (this.el.tagName.toLowerCase() !== 'select') return;

        const originClassList = this.el.classList;

        $(this.el).select2({
            tags: customOption,
            placeholder: $(this.el).attr('data-placeholder') || '',
            width: '100%'
        }).on('select2:select', () => {
            this.el.dispatchEvent(new Event('change'));
        });

        const $select2 = $(this.el).next('.select2');

        $select2.removeAttr('style');

        originClassList.forEach(cl => {
            if (cl && !cl.includes('select2')) {
                $select2.addClass(cl);
            }
        });

        this.select2Container = $select2;

    $select2.find('b[role="presentation"]').addClass('icon-chevron-down');

    }

    attachTyping(){
        const self = this;
        $(this.el).on('select2:open',function (params) {
        let $input = $('.select2-container--open .select2-search__field');
           $input.off('input');
           $input.on('input',function(e){
            if(this.value.length > 2)
            {
                const event = new CustomEvent('select2:noResultsTrigger', {
                    detail: { term: this.value }
                });

                setTimeout(() => {
                    let results = $('.select2-results__option');
                    if(results.length == 0 || (results.length == 1 && results[0].className.includes('--selectable'))){
                        console.log('miejsce do pobierania danych');
                       
                        self.el.dispatchEvent(event);

                    }
                  }, 100); 

            }
            })
        })
    }



    restartSelect2(term) {
        // $(this.el).trigger("change.select2");
        // $(this.el).trigger("change");
        // $(this.el).val(null).trigger('change');
        // $(this.el).select2({data: this.el.options});
        $(this.el).select2('close');
        $(this.el).select2('open');
        $(this.el).data('select2').dropdown.$search.val(term); // przefiltruj ponownie
        $(this.el).data('select2').dropdown.$search.trigger('keyup');
        // $(this.el).trigger({
        //     type: 'query',
        //     params: {
        //         term: term
        //     }
        // });

  
    }

    setEnpoint(enpoint, structure) {
        $(this.el).select2({
            ajax: {
                url: function (params) {
                    return enpoint + '/' + params.term ?? '';
                },
                data: function () {
                    return {}; // <-- nic nie dodaje do query stringa
                },
                dataType: 'json',
                delay: 250,
                processResults: function (data) {
                    return {
                        results: data.map(item => ({
                            id: item.name,
                            text: item.name,
                            postcode: item.postcode.join(',') // konwersja tablicy na string
                        }))
                    };
                },
                cache: true
            },
            placeholder: 'Wyszukaj...',
            minimumInputLength: 0, // <-- WAŻNE
            templateResult: function (item) {
                if (item.loading) return item.text;
                const $result = $('<span></span>')
                    .text(item.text)
                    .attr('data-postcode', item.postcode); // widoczne w dropdownie
                return $result;
            },
            templateSelection: function (item) {
                return item.text;
            }

        });

    }

    customsearching(){

        var $dropdown = $(this.el).data('select2').dropdown.$dropdown;
        $(this.el).data('select2').dropdown.$dropdown.find('.select2-results__option.select2-results__message').remove();
        const $li = $('<li>', {
            class: 'select2-results__option custom-searching',
            text: 'Wyszukiwanie...',
            'aria-disabled': 'true'
          });
      
          $dropdown.find('.select2-results__options').prepend($li);
    }

    endsearching(){
        $(this.el).data('select2').dropdown.$dropdown.find('.custom-searching').remove();
    }

    changePlaceholder(newPlaceholder){
        $(this.el).data('placeholder',newPlaceholder);
        $(this.el).data('select2').selection.placeholder.text = newPlaceholder;
        $(this.el).data('select2').$container.find('.select2-selection__placeholder').text(newPlaceholder);

    }



}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(".select2-enable").forEach(el => {
        new Select2FormBuilder(el);
    });
});
